import gql from 'graphql-tag';

import type { BlogDraft } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_POST_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation CreateFormatCompliantBlogPostDraft($id: ID!) {
    createFormatCompliantBlogPostDraft(id: $id) {
      ...BlogPostBuilderDraft
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_DRAFT}
`;

export const createFormatCompliantBlogPostDraft = async (originalDraftId: ID) => {
  const variables = {
    id: originalDraftId,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogDraft>(result.data);
};
